import {useEffect, useState} from "react";
import {validation} from "../../../../../helpers/ValidationHelper";

const defaultSettings = {
    overrideRfInhibitStatus: false,
    frequency: 0,
    powerLevel: 0,
    trim: 0
};

function validateFrequencyValue(value) {
    return value >= 2840000 && value <= 2870000;
}

function validatePowerLevelValue(value) {
    return value >= -300 && value <= 300;
}

function validateTrimValue(value) {
    return value >= -50 && value <= 50;
}

export default function UsePeakComARU2856CControl({pipe, defaultStepSize, onChanged, onApply}) {
    const [settings, setSettings] = useState(defaultSettings);
    const [stepSize, setStepSize] = useState(defaultStepSize);
    const [applying, setApplying] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const hasErrors = !!Object.keys(validationErrors).length;

    useEffect(() => {
        setSettings(pipe.settings ? {
            overrideRfInhibitStatus: pipe.settings["override_rf_inhibit_status"] || defaultSettings.overrideRfInhibitStatus,
            frequency: pipe.settings["frequency"] || defaultSettings.frequency,
            powerLevel: pipe.settings["power_level"] || defaultSettings.powerLevel,
            trim: pipe.settings["trim"] || defaultSettings.trim,
        } : defaultSettings);
    }, [pipe.id, pipe.settings]);

    function handleStepSizeChanged(value) {
        setStepSize(value);
    }

    function handleOverrideRfInhibitStatusChanged(value) {
        setSettings(Object.assign({}, settings, {overrideRfInhibitStatus: value}));
    }

    function handleFrequencyChanged(value) {
        setValidationErrors(validation(
            value,
            "frequency",
            validationErrors,
            validateFrequencyValue
        ));

        const newSetting = Object.assign(settings);

        newSetting.frequency = value;

        setSettings(newSetting);
    }

    function handlePowerLevelChanged(value) {
        setValidationErrors(validation(
            value,
            "power_level",
            validationErrors,
            validatePowerLevelValue
        ));

        const newSetting = Object.assign(settings);

        newSetting.powerLevel = value;

        setSettings(newSetting);
    }

    function handleTrimChanged(value) {
        setValidationErrors(validation(
            value,
            "trim",
            validationErrors,
            validateTrimValue
        ));

        const newSetting = Object.assign(settings);

        newSetting.trim = value;

        setSettings(newSetting);
    }

    function handleApplyClick() {
        if (hasErrors) return;

        setApplying(true);

        onChanged(pipe.id, {
            "override_rf_inhibit_status": settings.overrideRfInhibitStatus,
            "frequency": settings.frequency,
            "power_level": settings.powerLevel,
            "trim": settings.trim
        });

        onApply(pipe.id).finally(() => setApplying(false));
    }

    return {
        settings,
        stepSize,
        applying,
        hasErrors,
        validationErrors,
        handleStepSizeChanged,
        handleOverrideRfInhibitStatusChanged,
        handleFrequencyChanged,
        handlePowerLevelChanged,
        handleTrimChanged,
        handleApplyClick
    }
}